<div class="form-group">
  <label
    i18n="@@global.password"
    required
    for="password"
    [class.wallet-black-label]="isCargoWallet"
    >Password</label
  >
  <input
    type="password"
    [formControl]="passwordControl"
    autocomplete="off"
    class="form-control password-input"
    [class.invalid-wallet-border]="isCargoWallet"
    [class.invalid]="passwordControl.invalid && passwordControl.dirty"
    [class.valid]="passwordControl.valid && passwordControl.dirty"
    #password
    id="password"
  />
  <em
    (click)="
      password.type === 'text'
        ? (password.type = 'password')
        : (password.type = 'text')
    "
    [class.text-success]="password.type === 'text'"
    class="material-icons input-icon clickable"
    >remove_red_eye</em
  >
  @if (passwordControl.value.length > 0) {
    <span
      [class.password-wallet-underline]="isCargoWallet"
      [class]="'password-underline ' + 'password-' + getPasswordStrength(true)"
    ></span>
  }
  @if (hasError("required")) {
    <mat-error [class.wallet-error-msg]="isCargoWallet">
      <strong i18n="@@global.text-error-required-field">Required field</strong>
    </mat-error>
  }
  @if (passwordControl.valid) {
    <div>
      <span i18n="@@registration.user.password-strength"
        >Password Strength:
      </span>
      <span class="text-capitalize">{{ getPasswordStrength() }}</span>
    </div>
  }
  @if (hasError("pattern")) {
    <mat-error [class.wallet-error-msg]="isCargoWallet">
      <strong i18n="@@registration.user.text-error-password-pattern"
        >Password must have at least 8 characters and contain: Uppercase
        character(s), lowercase character(s), number(s), and no spaces
      </strong>
    </mat-error>
  }
</div>
